import getUmbracoEndPoint from "app/umbraco/helpers/UmbracoEndPoint";

export default (url: string | undefined): string => {
    const origin = getUmbracoEndPoint();

    if (!url) {
        return "";
    }

    url = url.toString()
        .replace(new RegExp(origin, "g"), "")
        .replace(new RegExp("http://localhost:3000", "g"), "")
        .replace(new RegExp("https://stage.wls.frontend.heyday.dk", "g"), "")
        .replace(new RegExp("https://www.work-live-stay.dk", "g"), "");

    return url.toString();
};